"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Industries_1 = __importDefault(require("../entity/FacetParts/Industries"));
const defaultValue = [
    { value: '金融', count: 123 },
    { value: 'マスコミ', count: 1234 },
    { value: 'IT', count: 1234 },
];
exports.generateIndustryEntity = (jsons = defaultValue) => Industries_1.default.fromJSON({
    buckets: jsons,
});
